import { httpClient, apiHttpClient } from './http'

export async function getBot({ botId, clientToken }) {
  try {
    const res = await httpClient.get(`/bot/${botId}`, {
      params: { client_token: clientToken }
    })
    return res.data
  } catch (err) {
    throw new Error(err.response.statusText)
  }
}

export async function getBotsList({ clientToken }) {
  try {
    const res = await httpClient.get('/bot/list', {
      params: { client_token: clientToken }
    })
    return res.data
  } catch (err) {
    throw new Error(err.response.statusText)
  }
}

export async function getBotsByEmail({ clientToken, email }) {
  try {
    const res = await apiHttpClient.get('/bots', {
      params: {
        client_token: clientToken,
        email
      }
    })
    return res.data
  } catch (err) {
    if (err.response && err.response.status === 403) {
      throw new Error(`You shall not pass!`)
    }
    throw new Error(`Oops! Couldn't load bots data`)
  }
}
